<script setup lang="ts">
import { useNetwork } from '@vueuse/core'
import { DotNoConnectionOverlay, LoadingOverlay } from '@/core/components'
import { useAuthStore } from './modules/auth'
const { isOnline } = useNetwork()
const auth = useAuthStore()
</script>

<template>
  <Toast />
  <Toast position="top-center" group="errorMessage">
    <template #message="slotProps">
      <div class="flex flex-col items-start flex-auto">
        <div class="flex items-center">
          <span class="font-bold">{{ slotProps.message.summary }}</span>
        </div>
        <ul class="mt-2 space-y-2">
          <li
            v-for="(error, index) in slotProps.message.detail.split(';')"
            :key="index"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </template>
  </Toast>
  <ConfirmDialog />
  <LoadingOverlay />
  <DotNoConnectionOverlay v-if="!isOnline" />
  <router-view v-if="!auth.loaders.isAuthenticating" />
</template>
